
import React, { memo, useEffect } from 'react';
import { router } from 'umi';
import styles from './index.less';
import classnames from 'classnames';
import DFImage from '@/components/dFImage';
import { IMovieItem } from '@/interface/index';
import {TLang, ReplaceText} from '@/utils/lang';
import { gioClick } from '@/utils/gioApi';
const filterDimensional = (d) => {
  let arr = d.split('/');
  arr = arr.splice(0, 3);
  // console.log(arr);
  return arr.map((item, idx) => (<span key={idx}>{item}</span>));
};

function Cinema(props: IMovieItem): JSX.Element {
  const { showButton = true, index = 0 } = props;

  /*** 曝光的代码 */
  useEffect(() => {
    const $dom = document.getElementById(`homeMovie${props?.index}`);
    if ($dom) {
       checkExposureGio();
    }
  }, []);

  const gioExposure = () => {
   checkExposureGio();
  };

  const checkExposureGio = () => {
    let sessionGio: any[] = JSON.parse(sessionStorage.getItem('film_homeMovie') || '[]') || [];
    const $dom = document.getElementById(`homeMovie${props?.index}`);
    // 计算页面置顶元素高度
    let minusTop = window.innerWidth * 0.228;
    if ($dom) {
      const offset = $dom.getBoundingClientRect();
      const offsetTop = offset.top;
      const offsetBottom = offset.bottom;
      // 进入可视区域（可视区域还需要减去置顶和置底元素的高度）
      if (offsetTop <= window.innerHeight && offsetBottom >= minusTop) {
        // 若当前进入可视区域的元素本身可视状态为false
        if (!sessionGio.includes(props?.index)) {
          // 更新当前的埋点曝光gioIng状态
          sessionGio.push(props?.index);
          sessionStorage.setItem('film_homeMovie', JSON.stringify(sessionGio));
          try {
            gioClick('电影-频道首页', {
              pagename: '电影首页',
              df_modulename: props.type === 'hot' ? '热映推荐' : '即将上映',
              df_elementname: props.type === 'hot' ? '购票' : '预售',
              floorNum: props.type === 'hot' ? 6 : 4,
              df_HPbanenrNum: Number(props?.index || 0)+1,
              JumpAddress: window.location.origin + `/newmovie/movieDetail?id=${props.id}&orderBy=${props.type === 'hot' ? 1 : ''}&detailBy=${props.type === 'future' ? 1 : ''}`,
              channle: '电影',
              contentTitle: props?.name
            }, 'DF_exposureEvent');
          } catch (error) {
            console.error(error);
          }
        }
      } else {
        if (sessionGio.includes(props?.index)) {
          sessionGio = sessionGio.filter((item) => item != props?.index);
          sessionStorage.setItem('film_homeMovie', JSON.stringify(sessionGio));
        }
      }
    }
  };

  useEffect(() => {
    const element = document.getElementById('pullToRefresh');
    element?.addEventListener('scroll', gioExposure);
    return () => {
      element?.removeEventListener('scroll', gioExposure);
    };
  }, []);
  /*** 曝光的代码 */

  // console.log('movieItem ...')
  const gotoDetail = function () {
    gioClick('电影-频道首页', {
      pagename: '电影首页',
      df_modulename: props.type === 'hot' ? '热映推荐' : '即将上映',
      df_elementname: props.type === 'hot' ? '购票' : '预售',
      floorNum: props.type === 'hot' ? 6 : 4,
      df_HPbanenrNum: Number(props?.index || 0)+1,
      JumpAddress: window.location.origin + `/newmovie/movieDetail?id=${props.id}&orderBy=${props.type === 'hot' ? 1 : ''}&detailBy=${props.type === 'future' ? 1 : ''}`,
      channle: '电影',
      contentTitle: props?.name
    });
    setTimeout(() => {
      router.push({
        pathname: '/movieDetail',
        query: {
          id: props.id,
          orderBy: props.type === 'hot' ? 1 : '', // 1 = 离我最近
          detailBy: props.type === 'future' ? 1 : '' // 1 = 待映
        }
      });
    }, 50);
  };

  // props.logo
  const isFuture = props.type === 'future';
  return <div className={styles.movieItemComtainer} id={`homeMovie${props?.index}`} onClick={gotoDetail}>
    <div className={`${styles.left} ${props.logo ? '' : 'logo'}`}>
      <DFImage key={props.id} src={props.logo} container="pullToRefresh"></DFImage>
    </div>
    <div className={styles.right}>
      <div className={styles.content}>
        <div className={styles.contentName}>{props.name}</div>
        <div className={classnames(styles.contentActor, styles.contentInfo)}><span>{TLang('主演', 'home', false, false, null)}: </span><span>{props.actor}</span></div>
        <div className={classnames(styles.contentDirector, styles.contentInfo)}><span>{TLang('导演', 'home', false, false, null)}: </span><span>{props.director}</span></div>
        {props.dimensional && <div className={styles.contentDimensinal}>{filterDimensional(props.dimensional)}</div>}
      </div>
      {showButton && <div
        className={classnames(styles.btn, { [styles.futureBtn]: isFuture })}
                     >
        {isFuture ? TLang('预售', 'home', false, false, null) : TLang('购票', 'home', false, false, null)}</div>}
    </div>

  </div>;
}
export default memo(Cinema);
